export default __webpack_public_path__ + "static/media/47.772cb354.png";